exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\nlabel[data-v-201dfa4e] {\n  display: block;\n}\n#fullnameChangePanel[data-v-201dfa4e] {\n  width: 900px;\n  margin-top: 10px;\n  padding-top:10px;\n  margin-left: auto;\n  margin-right: auto;\n  border-style: solid;\n  border-color: #E69200;\n  border-left: none;\n  border-right: none;\n  border-bottom: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-201dfa4e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserInfo/FullnameChangePanel.vue
// module id = 483
// module chunks = 0